import PropTypes from 'prop-types';

import { InfoIconOutline } from '../icons/icons';
import { Content } from './alert.styled';

export const Alert = (props) => {
  const { children, ...rest } = props;

  // render
  return <Content {...rest}><InfoIconOutline />{children}</Content>;
};

Alert.propTypes = {
  children: PropTypes.any.isRequired,
};
